import React, {Fragment} from "react";
import axios from "axios";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import {makeStyles} from "@material-ui/core/styles";
import DetailsTable from "../../common/DetailsTable";
import InfoIcon from '@material-ui/icons/Info';
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import "moment/locale/es";
import {handleConcursosDetailError} from "../../utils/errors";

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff",
    },
    dialog: {
        "& .MuiDialog-paper": {
            maxWidth: "700px",
        },
    },
    tooltip: {
        fontSize: "14px",
        fontWeight: "normal",
    },
}));

const DetailsModal = (props) => {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const [openSpinner, setOpenSpinner] = React.useState(false);
    const [data, setData] = React.useState({});

    const handleError = (error) => {
        setOpen(false);
        setOpenSpinner(false);
        handleConcursosDetailError(error)
    }

    const handleOpen = () => {
        setOpenSpinner(true)
        axios
            .get(window.ENV.API_URL + "/concursos/" + props.concursoId + "/")
            .then((res) => {
                setOpen(true);
                setData(res.data[0]);
                setOpenSpinner(false);
            })
            .catch((error) => handleError(error));
    };

    return (
        <Fragment>
            {/*<Button onClick={() => handleOpen()}>{props.label}</Button>*/}
            <Tooltip
                onClick={handleOpen}
                title={<span className={classes.tooltip}>{props.label}</span>}
            >
                <IconButton>
                    <InfoIcon/>
                </IconButton>
            </Tooltip>
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                scroll={"paper"}
                className={classes.dialog}
                fullWidth
            >
                <DialogTitle>Detalles del concurso</DialogTitle>

                <DialogContent dividers={true}>
                    <DetailsTable data={data}
                                  type={"archivados"}
                    />
                </DialogContent>
                <DialogActions>
                    <Button
                        style={{boxShadow: "none"}}
                        variant="contained"
                        onClick={() => setOpen(false)}
                    >
                        Cancelar
                    </Button>
                </DialogActions>
            </Dialog>
            <Backdrop className={classes.backdrop} open={openSpinner}>
                <CircularProgress color="inherit"/>
            </Backdrop>
        </Fragment>
    );
};

export default DetailsModal;
